import { useEffect, useState, createContext, useContext, } from "react";

const AuthContext = createContext(null);

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    // ✅ this runs BEFORE the first paint
    const token =
      localStorage.getItem("adminToken") ||
      sessionStorage.getItem("adminToken");
    return token ? { token } : null;
  });


  const setAuthToken = (token) => {
    sessionStorage.setItem('adminToken', token);
    setUser({ token });
  };

  const logout = () => {
    sessionStorage.removeItem('adminToken');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setAuthToken, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthProvider;
